export const UPDATE_PREM_DEDUCT_NOTE = "UPDATE_PREM_DEDUCT_NOTE";
export const TRANSFORM_PREM_DEDUCT_FILE_SUCCESS =
  "TRANSFORM_PREM_DEDUCT_FILE_SUCCESS";
export const HIDE_PREM_DEDUCT_FILE = "HIDE_PREM_DEDUCT_FILE";
